import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import Router from 'router/Router';
import { AuthContextProvider } from 'context/auth.context';
import theme from 'theme';
import { DashboardContextProvider } from 'context/dashboard.context';
import { SnackbarContextProvider } from 'context/snackbar.context';

function App() {
  return (
    <BrowserRouter>
      <AuthContextProvider>
        <ThemeProvider theme={theme}>
          <DashboardContextProvider>
            <SnackbarContextProvider>
              <Router />
            </SnackbarContextProvider>
          </DashboardContextProvider>
        </ThemeProvider>
      </AuthContextProvider>
    </BrowserRouter>
  );
}

export default App;
